import React, { FC } from "react";

export const Loading: FC = () => {
  return <div>Loading...</div>;
};
